export default "__VITE_ASSET__78b37b98__"